import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const LuggageListTable = () => {
  return (
    <View>
      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: 1,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }}>
          <Text>ITEM NO.</Text>
        </View>
        <View style={{ borderRight: 1, width: '10%' }}>
          <Text>MODE OF PKG.</Text>
        </View>
        <View style={{ borderRight: 1, width: '52%' }}>
          <Text style={{ marginVertical: 'auto' }}>CONTENT</Text>
        </View>
        <View style={{ borderRight: 1, width: '15%' }}>
          <Text style={{ marginVertical: 'auto' }}>VALUE</Text>
        </View>
        <View style={{ width: '15%' }}>
          <Text style={{ marginVertical: 'auto' }}>REMARK</Text>
        </View>
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>

      <View
        style={{
          flexDirection: 'row',
          textAlign: 'center',
          border: '1 1 1 0',
          height: 14.5,
        }}
      >
        <View style={{ borderRight: 1, width: '8%' }} />
        <View style={{ borderRight: 1, width: '10%' }} />
        <View style={{ borderRight: 1, width: '52%' }} />
        <View style={{ borderRight: 1, width: '15%' }} />
        <View style={{ width: '15%' }} />
      </View>
    </View>
  );
};

export default LuggageListTable;
